import * as React from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNotify } from 'react-admin';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Landing page for the Dotykačka connector: the backend callback redirects the
 * browser here with ?dotykacka=connected&locationId=… or ?dotykacka=error.
 */
export const DotykackaReturnPage: React.FC = () => {
  const { t } = useTranslation();
  const notify = useNotify();
  const navigate = useNavigate();
  const { search } = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(search);
    const locationId = params.get('locationId');

    if (params.get('dotykacka') === 'connected' && locationId) {
      notify(t('dotykacka.connectedNotice'), { type: 'success' });
      navigate(`/locationsManagement/${locationId}`, { replace: true });
    } else {
      notify(t('dotykacka.errors.connectRejected'), { type: 'error' });
      navigate('/locationsManagement', { replace: true });
    }
  }, [search, navigate, notify, t]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 'var(--space-10)' }}>
      <CircularProgress />
    </Box>
  );
};

export default DotykackaReturnPage;
